import {Component, Inject, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {DataService} from '@irb-common/services/data.service';
import {IrbAppEvents} from '@irb/app.events';
import {AppService} from '@irb/app.service';
import {DropdownFilterComponent} from '@irb/irb-common/components/dropdown-filter/dropdown-filter.component';
import {IDropdownItem} from '@irb/irb-common/models/dropdown.model';
import {IAnalysisPortDto, ISmartFilterDto} from '@irb/irb-editors/irb-editors.model';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';
import {RebalanceService} from '@irb/irb-editors/rebalance/rebalance.service';
import {
    ICreateRebalance,
    IPortfoliosByModel,
    IrbCreateRebalanceService,
    IRebalanceTypeItem
} from './irb-create-rebalance.service';
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import { ISaveRebalanceResponse, ISaveRebalanceStatus, ISaveRebalanceAsync } from '@irb/irb-editors/rebalance/irb-rebalance.model';
import { interval, Subscription } from 'rxjs';
import {IAlertDialogData} from "@irb/app.model";
import {EditorModelService} from "@irb/irb-editors/editor-model/editor-model.service";

@Component({ standalone: false,
    selector: 'irb-create-rebalance',
    templateUrl: './irb-create-rebalance.component.html',
    styleUrls: ['./irb-create-rebalance.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class IrbCreateRebalanceComponent implements OnInit{
    @ViewChild('IrbSelectedRebalanceTypeDropdown') selectReference: DropdownFilterComponent;
    @Input() ignoreUnsavedChanges: boolean = false;
    rebalanceTypeLists: any[];
    selectedRebalanceType: any = new FormControl('');
    display = false;
    allowRebalanceSubmit: boolean;
    allowOnlyRebalanceSetUp: boolean;
    protected saveRebalanceThreshold: number = 2000;
    checkSaveRebalanceSub: Subscription;
    checkGetPortfoliosRebalSub: Subscription;
    private isTLHSetInGlobal = true;
    investCashSetting = 'Securities';
    ENABLE_INVEST_MODEL_CASH: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<IrbCreateRebalanceComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private crbservice: IrbCreateRebalanceService,
        private readonly router: Router,
        private ds: DataService,
        private as: AppService,
        private rs: RebalanceService,
        private ies: IrbEditorsService,
        private editorModelService: EditorModelService,
        public ats: AnalyticsService) {
            const globSet: any = this.editorModelService.getGlobalSettings();
            if (globSet)
                this.isTLHSetInGlobal = globSet.isTlhLotLevel || globSet.isTlhPositionLevel;
            this.allowRebalanceSubmit = (typeof this.data.allowRebalanceSubmit !== "undefined") ? this.data.allowRebalanceSubmit : true;
            this.allowOnlyRebalanceSetUp = (typeof this.data.allowOnlyRebalanceSetUp !== "undefined") ? this.data.allowOnlyRebalanceSetUp : false;

            const rebalanceTypeArr = this.crbservice.getRebalanceTypeListObject(this.as.getItem('IRB_APP_CONFIG')?.isTlhWsaEnabled);
            if (this.isTLHSetInGlobal) {
                rebalanceTypeArr.forEach((rebType: any) => {
                    if (rebType.gvalue === 'TLH_FULL_REBALANCE') {
                        delete rebType.customToolTipWhenDisabled;
                    }
                })
            }
            this.rebalanceTypeLists = rebalanceTypeArr.map(this.mapRebalanceType);
            this.selectedRebalanceType.setValue(this.rebalanceTypeLists[0]);

            this.as.getUserDetails().subscribe((res: any) => {
                if (res && res.createRebalanceThreshold) {
                    this.saveRebalanceThreshold = res.createRebalanceThreshold;
                }
            });
    }

    ngOnInit(){
        this.ENABLE_INVEST_MODEL_CASH = this.as.getItem("IRB_APP_CONFIG")?.featureFlags?.ENABLE_INVEST_MODEL_CASH === true;
        if(this.data.rebalName === "Generate and/or invest cash"){
            this.selectedRebalanceType.setValue(this.rebalanceTypeLists[1]);
        }
    }

    navigateToCreateRebalToEditParams() {
        this.ats.trackPassiveEvent("md_quick_rebal_edit");

        if (this.data.portfolioIdsList && this.data.portfolioIdsList.length > 0 &&
            this.selectedRebalanceType !== null && this.selectedRebalanceType !== undefined && 
            this.selectedRebalanceType.value !== null && (this.selectedRebalanceType.value as any).value !== undefined) {
            this.ies.getPortfoliosRebal(this.data.portfolioIdsList).subscribe((data: any) => {
                this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
                this.checkGetPortfoliosRebal(data.responseUtilityMap.statusId);
            }, () => {});
        } else {
            if (!(this.data.portfolioIdsList && this.data.portfolioIdsList.length !== 0)) {
                if (this.data.modelId) {
                    if (this.data.closeParentBeforeNavigate && this.data.parentComponentThis) {
                        this.data.parentComponentThis.cancel();
                    }
                    this.createAnalysysGetPotfolioListForModel('edit');
                }
            }
        }
    }

    checkGetPortfoliosRebal(rprasId: string) {
        this.checkGetPortfoliosRebalSub = interval(3000).subscribe(() => {
            this.ies.getPortfoliosRebalStatus(rprasId).subscribe((response: any) => {
                if(response.responseUtilityMap.requestStatus.toUpperCase() == "COMPLETED") {
                    this.checkGetPortfoliosRebalSub.unsubscribe();
                    this.completeGetPortfoliosRebal({
                        responseStatus: "SUCCESS",
                        responseData: JSON.parse(response.responseData)
                    } as any);
                } else if(response.responseUtilityMap.requestStatus.toUpperCase() == "FAILED") {
                    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                        dType: 'ERROR',
                        dTitle: '',
                        dProceedBtnLabel: '',
                        msg: response.failMsg,
                        onProceed: () => {}
                    } as IAlertDialogData);
                    this.checkGetPortfoliosRebalSub.unsubscribe();
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                } else if(response.responseUtilityMap.requestStatus.toUpperCase() == "INPROGRESS") {
                }
            });
        });
    }

    completeGetPortfoliosRebal(data: any) {
        if (data?.responseStatus === 'SUCCESS') {
            let smartFilterDto = {analysisPortDtoList: []} as ISmartFilterDto;
            data.responseData.forEach((pf: IAnalysisPortDto) => {
                smartFilterDto.analysisPortDtoList.push(pf);
            });

            let eventData: any = {
                fullscreen: true,
                'smartFilterDto': smartFilterDto,
                source: "portfolioDialog"
            };

            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.fireCreateRebalance(eventData);
        } else {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }
    }

    mapRebalanceType(rebalanceType: IRebalanceTypeItem): IDropdownItem {
        let rebItem: any = {name: rebalanceType.label, value: rebalanceType};
        if (rebalanceType.customToolTipWhenDisabled) {
            rebItem.customToolTipWhenDisabled = rebalanceType.customToolTipWhenDisabled;
            rebItem.class = 'grid-cell-disabled';
            rebItem.notClickableItem = true;
        }
        return rebItem;
    }

    setChainTypeOptions(searchStr: any) {
        const f = DropdownFilterComponent.getFilteredList(searchStr, this.rebalanceTypeLists);
        this.selectReference.set(f);
    }

    fireCreateRebalance(eventData: any) {
        let eventDataNew = {
            fullscreen: true,
            ignoreUnsavedChanges: this.ignoreUnsavedChanges,
            data: {
                analysisType: (this.selectedRebalanceType.value as any).value.label,
                source: "portfolioDialog"
            }
        };
        eventDataNew = Object.assign(eventDataNew, eventData);
        this.rs.getRebalanceTypeEvent(eventDataNew);
    }

    createEditSubmitRebalance(btnAction: string) {
        this.ats.trackPassiveEvent("lc_quickrebal_submit");
        const rebalObj: ICreateRebalance = {
            analysisType: (this.selectedRebalanceType.value as any).value.label,
            scheduleType: 'Adhoc',
            portfolioArray: this.data.portfolioIdsList
        };
        if (this.ENABLE_INVEST_MODEL_CASH && rebalObj?.analysisType === 'Invest cash only') {
          rebalObj.investCashSetting = this.investCashSetting;
        }
        if (this.data.portfolioIdsList && this.data.portfolioIdsList.length) {
            this.createRebalanceWithPortfolio(btnAction, rebalObj);
        } else if (this.data.serviceURL) {
            this.crbservice.getIdsByFilterCriteria(this.data).subscribe((data: any) => {
                if (data.responseStatus === 'SUCCESS') {
                    const portfolioArray = data.responseData;
                    const deselectedFromSelectAllRecords = this.data.deselectedFromSelectAllRecords;
                    if (deselectedFromSelectAllRecords && deselectedFromSelectAllRecords.length) {
                        for (let i = 0; i < deselectedFromSelectAllRecords.length; i++) {
                            const index = portfolioArray.indexOf(deselectedFromSelectAllRecords[i].portfolioId, 0);
                            if (index > -1) {
                                portfolioArray.splice(index, 1);
                            }
                        }
                    }
                    if (portfolioArray && portfolioArray.length) {
                        this.data.portfolioIdsList = portfolioArray;
                        rebalObj.portfolioArray = portfolioArray;
                        this.createRebalanceWithPortfolio(btnAction, rebalObj);
                    }
                }
            });
        } else if (this.data.modelId) {
            this.createAnalysysGetPotfolioListForModel(btnAction);
        } else {
            this.createRebalanceWithPortfolio(btnAction, rebalObj);
        }
    }

    createRebalanceWithPortfolio(btnAction: string, rebalObj: ICreateRebalance) {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        this.crbservice.createRebalWithPortfolios(rebalObj).subscribe((data: any) => {
            if (data.responseStatus === 'SUCCESS') {
                const rebalObj1: ICreateRebalance = {
                    portfolioArray: this.data.portfolioIdsList,
                    analysisId: (data.responseData.analysisId).toString(), 
                    schedulerId: data.responseUtilityMap.schedulerID
                };
                if (btnAction === 'edit') {
                    const rebalObj2: ICreateRebalance = {
                        portfolioDtoList: this.data.portfolioIdsList,
                        scheduleType: 'Adhoc',
                        analysisId: (data.responseData.analysisId).toString(),
                        rebalanceType: (this.selectedRebalanceType.value as any).value.glabel,
                        rebalanceSubType: (this.selectedRebalanceType.value as any).value.label,
                        testFlag: 1,
                        navBackModule: "CREATE_REBALANCE",
                        schedulerId: data.responseUtilityMap.schedulerID
                    };
                    this.ds.changeMessage(rebalObj2);
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                    if (this.data.closeParentBeforeNavigate && this.data.parentComponentThis) {
                        this.data.parentComponentThis.cancel();
                    }
                    this.getRebalanceEventDetails();
                    //this.router.navigate(['/rebalancing/create-a-rebalance']);
                } else {
                    this.getRebalancePortDetail(rebalObj1);
                }
            } else {
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            }
        });
    }

    getRebalanceEventDetails(){
        const rebalObj: ICreateRebalance = {
            analysisType: (this.selectedRebalanceType.value as any).value.label,
            scheduleType: 'Adhoc',
            portfolioArray: this.data.portfolioIdsList
        };
        this.crbservice.createRebalWithPortfolios(rebalObj).subscribe((data: any) => {
            if (data.responseStatus === 'SUCCESS') {
                const rebalObj2: ICreateRebalance = {
                    portfolioArray: this.data.portfolioIdsList,
                    analysisId: (data.responseData.analysisId).toString(),
                    schedulerId: data.responseUtilityMap.schedulerID
                };

                this.crbservice.getRebalancePortDetail(rebalObj2).subscribe((data: any) => {
                    if (data.responseStatus === 'SUCCESS') {
                    } else {
                        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                    }
                });
            }
        });
    }

    getRebalancePortDetail(req: ICreateRebalance) {
        this.crbservice.getRebalancePortDetail(req).subscribe((data: any) => {
            if (data.responseStatus === 'SUCCESS') {
                data.responseData.schedulerFrequency = 'none';
                data.responseData.scheduler = {scheduleType: 'Adhoc', schedulerId: req.schedulerId};
                this.saveRebalance(data.responseData);
            } else {
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            }
        });
    }

    saveRebalance(data: any) {
        if(data.smartFilterDto.analysisPortDtoList.length >= this.saveRebalanceThreshold) {
            this.crbservice.saveRebalanceAsync(data).subscribe((data: ISaveRebalanceAsync) => {
                this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
                this.checkSaveRebalanceAsyncStatus(data.rprasId);
              }, () => {});
        } else {
            this.crbservice.saveRebalance(data).subscribe((response: any) => {
                this.completeSaveRebalance({
                    responseStatus: "SUCCESS",
                    responseUtilityMap: {
                        analysisId: response.responseUtilityMap.analysisId,
                        rebalanceResultId: response.responseUtilityMap.rebalanceResultId,
                        rebalanceName: response.responseUtilityMap.rebalanceName 
                    }
                } as ISaveRebalanceResponse);
            });
        }
    }

    checkSaveRebalanceAsyncStatus(rprasId: string) {
        this.checkSaveRebalanceSub = interval(3000).subscribe(() => {
            this.crbservice.getSaveRebalanceStatus(rprasId).subscribe((response: ISaveRebalanceStatus) => {
                if(response.status.toUpperCase() == "COMPLETED") {
                    this.checkSaveRebalanceSub.unsubscribe();
                    this.completeSaveRebalance({
                        responseStatus: "SUCCESS",
                        responseUtilityMap: {
                            analysisId: response.analysisId,
                            rebalanceResultId: response.rebalanceResultId,
                            rebalanceName: response.rebalanceName 
                        }
                    } as ISaveRebalanceResponse);
                } else if(response.status.toUpperCase() == "FAILED") {
                    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                        dType: 'ERROR',
                        dTitle: '',
                        dProceedBtnLabel: '',
                        msg: response.failMsg,
                        onProceed: () => {}
                    } as IAlertDialogData);
                    this.checkSaveRebalanceSub.unsubscribe();
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                } else if(response.status.toUpperCase() == "INPROGRESS") {
                }
            });
        });
    }

    completeSaveRebalance(response: ISaveRebalanceResponse) {
        if (response.responseStatus === 'SUCCESS') {
            this.submitPortfoliosToQueue({
                'Package': (response.responseUtilityMap.analysisId).toString(),
                'RebalanceResult': (response.responseUtilityMap.rebalanceResultId).toString()
            });
        } else {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }
    }

    submitPortfoliosToQueue(req: any) {
        this.crbservice.submitPortfoliosToQueue(req).subscribe(() => {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            if (this.data.closeParentBeforeNavigate && this.data.parentComponentThis) {
                this.data.parentComponentThis.cancel();
            }
            this.router.navigate(['/rebalancing/result-summary/',req.RebalanceResult]);
        });
    }

    createNewRebalances() {
        let eventData = {fullscreen: true, source:"portfolioDialog"};
        this.fireCreateRebalance(eventData);
    }

    selectOption(event: any) {
        this.selectedRebalanceType.setValue(event);
    }

    createAnalysysGetPotfolioListForModel(btnAction: string) {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        const rebalObj: ICreateRebalance = {
            analysisType: (this.selectedRebalanceType.value as any).value.label,
            scheduleType: "Adhoc"
        };
        this.crbservice.createNewRebalances(rebalObj).subscribe((data: any) => {
            if (data.responseStatus === 'SUCCESS') {
                let sfModelDtoList: any = [];
                if (Array.isArray(this.data.modelId)) {
                    this.data.modelId.forEach((mid: any) => {
                        sfModelDtoList.push({modelId: mid.toString()});
                    });

                } else {
                    sfModelDtoList.push({modelId: this.data.modelId.toString()});
                }


                const modelObj: IPortfoliosByModel = {
                    analysisId: (data.responseData).toString(),
                    analysisPortDtoList: [],
                    analysisType: (this.selectedRebalanceType.value as any).value.label,
                    isCategoryAll: false,
                    isCategoryBlank: false,
                    isModelAll: false,
                    isModelBlank: false,
                    modelUpdated: false,
                    sfCategoryDtoList: [],
                    sfModelDtoList: sfModelDtoList,
                    smartFilterDays: null
                };
                this.crbservice.getSmartFilteredPortfolios(modelObj).subscribe((res: any) => {

                    if (btnAction === 'edit') {

                        // this.navigateToCreateRebalToEditParams();
                        let smartFilterDto = {analysisPortDtoList: [],
                            analysisType: (this.selectedRebalanceType.value as any).value.label,
                            isCategoryAll: false,
                            isCategoryBlank: false,
                            isModelAll: false,
                            isModelBlank: false,
                            modelUpdated: false,
                            sfCategoryDtoList: [],
                            sfModelDtoList: sfModelDtoList,
                            smartFilterDays: null } as ISmartFilterDto;
                        res.responseData.forEach((pf: IAnalysisPortDto) => {
                            smartFilterDto.analysisPortDtoList.push(pf);
                        });
                        let eventData: any = {
                            fullscreen: true,
                            'smartFilterDto': smartFilterDto,
                            source: "portfolioDialog"
                        };
                        if (this.data.modelId) {
                            eventData.modelId = this.data.modelId;
                            eventData.modelName = this.data.modelName;
                        }

                        this.fireCreateRebalance(eventData);

                    } else {
                        this.data.portfolioIdsList = [];
                        res.responseData.forEach((item: any) => {
                            this.data.portfolioIdsList.push(item.portfolioId);
                        });
                        if (this.data.portfolioIdsList.length !== 0) {
                            const rebalObj2: ICreateRebalance = {
                                analysisType: (this.selectedRebalanceType.value as any).value.label,
                                scheduleType: 'Adhoc',
                                portfolioArray: this.data.portfolioIdsList
                            };
                            if (this.ENABLE_INVEST_MODEL_CASH && rebalObj2.analysisType === 'Invest cash only') {
                              rebalObj2.investCashSetting = this.investCashSetting;
                            }
                            this.createRebalanceWithPortfolio(btnAction, rebalObj2);
                        }
                    }

                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                });
            } else
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        });
    }

    close() {
        this.dialogRef.close();
    }
}
